
export default  {
    name: "Loading Zones",
    mapLayerIcon: "/mapicons/loadingzones/truck-loading-onwhite.png",
    defaultOn: false,
    showOnMap: true,
    publishLayer: "tasWebapp.cityboundaries.enable",
    geoJsonUrl: "static/lz.geojson",
    geoJsonPopups: true,
    geoOptions: {
        icon: "/mapicons/loadingzones/truck-loading.png",
    }
}
